
import { useState } from 'react';

export default function Footer() {
  const [showToast, setShowToast] = useState(false);

  const handleEmailClick = async () => {
    const email = 'jisung.develop@gmail.com';
    try {
      await navigator.clipboard.writeText(email);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 2000);
    } catch (err) {
      // 클립보드 API가 지원되지 않는 경우 fallback
      const textArea = document.createElement('textarea');
      textArea.value = email;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        setShowToast(true);
        setTimeout(() => setShowToast(false), 2000);
      } catch (fallbackErr) {
        console.error('복사 실패:', fallbackErr);
      }
      document.body.removeChild(textArea);
    }
  };

  const handleGithubClick = () => {
    window.open('https://github.com/zzzzseong', '_blank');
  };

  const handleBlogClick = () => {
    window.open('https://zzzzseong.tistory.com/', '_blank');
  };

  return (
    <footer className="bg-[#0a0e13] border-t border-[#30363d] py-12 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Left - Brand */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold text-white">정지성</h3>
            <p className="text-gray-400 leading-relaxed">
              <strong className="text-[#3ECF8E]">Backend Developer</strong><br />
              {/* MSA 기반 메시징 시스템 유지보수 및<br /> */}
              {/* 대규모 트래픽 처리 전문 */}
            </p>
            {/* Social Links */}
            <div className="flex items-center gap-4 pt-2">
              <div className="relative group">
                <button
                  onClick={handleGithubClick}
                  className="w-10 h-10 bg-[#161b22] border border-[#30363d] rounded-lg flex items-center justify-center hover:border-[#3ECF8E] hover:bg-[#3ECF8E]/10 transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-github-fill text-gray-400 hover:text-[#3ECF8E]" />
                </button>
                {/* Tooltip */}
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1.5 bg-[#161b22] border border-[#30363d] rounded-lg text-xs text-gray-300 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-10">
                  GitHub
                  <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-px">
                    <div className="w-2 h-2 bg-[#161b22] border-r border-b border-[#30363d] rotate-45"></div>
                  </div>
                </div>
              </div>
              <div className="relative group">
                <button
                  onClick={handleBlogClick}
                  className="w-10 h-10 bg-[#161b22] border border-[#30363d] rounded-lg flex items-center justify-center hover:border-[#3ECF8E] hover:bg-[#3ECF8E]/10 transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-article-line text-gray-400 hover:text-[#3ECF8E]" />
                </button>
                {/* Tooltip */}
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1.5 bg-[#161b22] border border-[#30363d] rounded-lg text-xs text-gray-300 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-10">
                  Tech Blog
                  <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-px">
                    <div className="w-2 h-2 bg-[#161b22] border-r border-b border-[#30363d] rotate-45"></div>
                  </div>
                </div>
              </div>
              <div className="relative group">
                <button
                  onClick={handleEmailClick}
                  className="w-10 h-10 bg-[#161b22] border border-[#30363d] rounded-lg flex items-center justify-center hover:border-[#3ECF8E] hover:bg-[#3ECF8E]/10 transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-mail-line text-gray-400 hover:text-[#3ECF8E]" />
                </button>
                {/* Tooltip */}
                <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1.5 bg-[#161b22] border border-[#30363d] rounded-lg text-xs text-gray-300 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-10">
                  jisung.develop@gmail.com
                  <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-px">
                    <div className="w-2 h-2 bg-[#161b22] border-r border-b border-[#30363d] rotate-45"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Center - Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">Quick Links</h4>
            <div className="space-y-2">
              <a href="#about" className="block text-gray-400 hover:text-[#3ECF8E] transition-colors duration-300">
                About Me
              </a>
              <a href="#skills" className="block text-gray-400 hover:text-[#3ECF8E] transition-colors duration-300">
                Skills
              </a>
              <a href="#experience" className="block text-gray-400 hover:text-[#3ECF8E] transition-colors duration-300">
                Experience
              </a>
              <a href="#projects" className="block text-gray-400 hover:text-[#3ECF8E] transition-colors duration-300">
                Projects
              </a>
            </div>
          </div>

          {/* Right - Contact */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">Contact</h4>
            <div className="space-y-3">
              <button
                onClick={handleEmailClick}
                className="flex items-center gap-3 text-gray-400 hover:text-[#3ECF8E] transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-mail-line" />
                <span>jisung.develop@gmail.com</span>
              </button>
              <button
                onClick={handleGithubClick}
                className="flex items-center gap-3 text-gray-400 hover:text-[#3ECF8E] transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-github-line" />
                <span>GitHub</span>
              </button>
              <button
                onClick={handleBlogClick}
                className="flex items-center gap-3 text-gray-400 hover:text-[#3ECF8E] transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-article-line" />
                <span>Tech Blog</span>
              </button>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#30363d] to-transparent mb-8" />

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-gray-500 text-sm">
            {/* © 2024 정지성. All rights reserved. */}
          </div>
        </div>
      </div>

      {/* Toast Notification */}
      {showToast && (
        <div className="fixed top-8 left-1/2 -translate-x-1/2 z-50 animate-toast-slide-in">
          <div className="relative bg-gradient-to-br from-[#161b22] via-[#0d1117] to-[#161b22] border border-[#3ECF8E]/50 rounded-xl px-6 py-4 shadow-2xl shadow-[#3ECF8E]/20 backdrop-blur-sm">
            {/* Glow effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#3ECF8E]/10 via-transparent to-[#2dd4bf]/10 rounded-xl blur-sm" />
            
            <div className="relative flex items-start gap-4">
              {/* Icon with animation */}
              <div className="flex-shrink-0 mt-0.5">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#3ECF8E] to-[#2dd4bf] flex items-center justify-center shadow-lg shadow-[#3ECF8E]/30">
                  <i className="ri-checkbox-circle-fill text-white text-xl animate-icon-bounce" />
                </div>
              </div>
              
              {/* Content */}
              <div className="flex flex-col gap-2 flex-1">
                <span className="text-white font-semibold text-base">이메일 주소가 복사되었습니다!</span>
                <div className="flex items-center gap-2">
                  <i className="ri-mail-line text-[#3ECF8E] text-sm" />
                  <span className="text-[#3ECF8E] font-mono text-sm font-medium tracking-wide">jisung.develop@gmail.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
}
